import { DocFrontmatter } from '../types';

const FRONTMATTER_BLOCK = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/;

/**
 * Minimal flat-scalar YAML frontmatter parser. Only supports `key: value`
 * lines (strings/numbers) — no arrays or nested objects. Sufficient for the
 * DocFrontmatter schema; switch to `gray-matter` if that ever changes.
 */
export function parseFrontmatter(raw: string): { frontmatter: DocFrontmatter; body: string } {
  const match = FRONTMATTER_BLOCK.exec(raw);

  if (!match) {
    throw new Error('Doc content is missing a frontmatter block (--- ... ---).');
  }

  const [, rawFrontmatter, body] = match;
  const fields: Record<string, string> = {};

  for (const line of rawFrontmatter.split(/\r?\n/)) {
    if (!line.trim()) continue;
    const separatorIndex = line.indexOf(':');
    if (separatorIndex === -1) continue;

    const key = line.slice(0, separatorIndex).trim();
    const value = line
      .slice(separatorIndex + 1)
      .trim()
      .replace(/^["']|["']$/g, '');
    fields[key] = value;
  }

  const required = ['title', 'slug', 'section', 'order'] as const;
  for (const key of required) {
    if (!fields[key]) {
      throw new Error(`Doc frontmatter is missing required field "${key}".`);
    }
  }

  const frontmatter: DocFrontmatter = {
    title: fields.title,
    slug: fields.slug,
    section: fields.section,
    order: Number(fields.order),
    description: fields.description,
  };

  return { frontmatter, body: body.trim() };
}
